module.exports = __webpack_public_path__ + "images/emoji/capital_abcd.73640f12b7d603c25627.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/capital_abcd.png
// module id = SPns
// module chunks = 2